import { put } from 'redux-saga/effects'
import { fetchChatConfigAction } from '../../handles'
import { fetchChatConfig, FetchChatConfigResponse } from '../_http/chat'

export function* fetchChatConfigSaga(action: ReturnType<typeof fetchChatConfigAction.request>) {
  const { campaignId, ownerId } = action.payload
  try {
    const response: FetchChatConfigResponse = yield fetchChatConfig({ campaignId, ownerId })
    yield put(fetchChatConfigAction.success({ chatConfig: response.chatConfigs }))
  } catch (error) {
    console.log({ fetchChatConfigSagaError: error })
    yield put(fetchChatConfigAction.failure())
  }
}
